import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { CancellationPolicyTimeline } from 'components/ProductContentsPane/CancellationPolicyTimeline/CancellationPolicyTimeline';
import { ProductShape } from 'lib/util/productShape';
import { LinkableTextArea } from 'components/LinkableTextArea/LinkableTextArea';

interface Props {
  product: ProductShape;
}

export const TourInformation = ({ product }: Props) => {
  const { t } = useTranslation();

  const itemLists: Array<{
    header: string;
    items: string[];
  }> = [
    {
      header: t("What's Included"),
      items: product.inclusions,
    },
    {
      header: t("What's Not Included"),
      items: product.exclusions,
    },
    {
      header: t('Requirements'),
      items: product.requirements,
    },
    {
      header: t('Restrictions'),
      items: product.restrictions,
    },
    {
      header: t('What to Bring'),
      items: product.whatToBring,
    },
    {
      header: t('Additional Info'),
      items: product.otherInfo,
    },
    ...(product.minimumParticipants
      ? [
          {
            header: t('Minimum Participants'),
            items: [`${product.minimumParticipants}`],
          },
        ]
      : []),
  ].filter((i) => i.items.length > 0);

  return (
    <ul className="c-list">
      {itemLists.map((itemList, idx) => (
        <li key={idx} className="c-list__item">
          <h3 className="c-list__item__title">{itemList.header}</h3>
          <ul className="c-list__item__body">
            {itemList.items.map((item, itemIdx) => (
              <li key={itemIdx}>
                <LinkableTextArea>{item}</LinkableTextArea>
              </li>
            ))}
          </ul>
        </li>
      ))}
      <li className="c-list__item">
        <h3 className="c-list__item__title">{t('Cancellation Policies')}</h3>
        <div className="c-list__item__body">
          <CancellationPolicyTimeline
            cancellationPolicies={product.cancellationPolicies}
            currency={product.currency}
          />
        </div>
      </li>
    </ul>
  );
};
